module.exports = __webpack_public_path__ + "755f317eae5a4b130680280a7a4787f6.jpg";